module.exports = __webpack_public_path__ + "img/TechGatherStone3_ua.a220b035.webp";